module.exports = __webpack_public_path__ + "img/16.923aacc8.png";